import { UnstyledButton, Group, Text, Badge, Tooltip } from "@mantine/core";
import { AppIcon } from "../common/AppIcon";
import { IconSparkle, IconSparkles, IconSparklesFilled } from "@tabler/icons-react";
import classes from "./Sidebar.module.css";

/**
 * A single navigation entry. Renders icon-only + tooltip when `collapsed`.
 */
export function NavItem({ item, active, collapsed, onClick }) {
  const button = (
    <UnstyledButton
      className={`${classes.navItem} ${collapsed ? classes.collapsed : ""}`}
      data-active={active || undefined}
      onClick={onClick}
      aria-label={item.label}
    >
      <span className={classes.navIcon}>
        <AppIcon
          name={item.icon}
          size={20}
          color={
            item.id === "magia" ? "var(--mantine-color-primary-6)" : undefined
          }
        />
      </span>

      {!collapsed && (
        <>
          <Text component="span" className={classes.navLabel} inherit c="black" fz={13}>
            {item.label}
          </Text>
          {item.badge && (
            <Badge
              size="sm"
              radius="sm"
              variant="light"
              color="pink"
              tt="none"
              leftSection={<IconSparklesFilled size={11} />}
            >
              {item.badge}
            </Badge>
          )}
        </>
      )}
    </UnstyledButton>
  );

  if (collapsed) {
    return (
      <Tooltip label={item.label} position="right" withArrow openDelay={200}>
        {button}
      </Tooltip>
    );
  }
  return button;
}

export default NavItem;
